// api.js
import axios from "axios";
import { AWS_LINK, DEV_LINK } from "../Static/static";


// Create an Axios instance
// DEV: http://localhost:3333/api/
// NOTE: current alb needs to route53 -> domain -> alb Alias ..

const LINK = process.env.NODE_ENV === "production" ? AWS_LINK : DEV_LINK;
const API = axios.create({
  withCredentials: true,
  baseURL: LINK + "/api",
  timeout: 90000,
  timeoutErrorMessage: "Request timed out. Please try again.",
});

API.interceptors.request.use(
  async (config) => {
    // Access token
    const stored_role = localStorage.getItem('role');
    if (stored_role) {
      const parse = JSON.parse(stored_role);
      const token = parse.token;
      if (token) {
        config.headers['Authorization'] = 'Bearer ' + token; 
      }
    }
    if (config.data && config.data.location_id) {
      config.headers['X-Location-ID'] = config.data.location_id.toString();
    }
    if (config.data && config.data.district_id) {
      config.headers['X-District-ID'] = config.data.district_id.toString();
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
API.interceptors.response.use(
  (response) => {
  if (response.headers) {
    const token = response.headers['x-access-token']
      if (token) {
        try {
          const storedRoleRaw = localStorage.getItem('role');
          if (storedRoleRaw) {
            const storedRole = JSON.parse(storedRoleRaw);
            storedRole.token = token;
            localStorage.setItem('role', JSON.stringify(storedRole));
          }
        } catch (error) {
          console.error('Unable to set new x-access-token', error);
        }
      }
  }
    return response; // Return response data
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      switch(status) {
        case 401:
          console.error("401 Unauthorized: Token might have expired.");
          sessionStorage.clear();
          localStorage.clear(); 
          return Promise.reject({ message: "Session expired. Please log in.", status });
        case 426:
          return Promise.reject({ message: data ? data: "Unable to confirm your plan details", status });
        case 403:
          return Promise.reject({ isForbidden: true, message: 'Forbidden, lack of permissions.', status});
        case 407:
            return Promise.reject({ isForbidden: true, message: 'Re-authentication required for google drive. Settings > External sync > Google drive', status});
        default:
          return Promise.reject({ message: data ? data : "An error occurred." });
      }    
    } 
    else if (error.request) {
      console.error("Network Error: No response from server.");
      return Promise.reject({
        message: "Network error. Please check your connection.",
      });
    } 
    else {
      return Promise.reject({
        message: "Unexpected error occurred.",
      });
    }
  }
);

export default API;

